import axios from 'axios';
import CONFIG from '../config';

export const makeContact = (payload) => axios.post(`${CONFIG.API_BASE}/contacts`, {
  ...payload,
}, {
  headers: { Authorization: `Bearer ${CONFIG.API_TOKEN}` }
}).then(response => response.data);
